import React, { useState } from "react";
import "../Address.css";
import { useApiStore } from "../hooks/ApiStoreContext";

const AddressForm = ({ address, onSave, onCancel }) => {
  const apiStore = useApiStore();
  const [name, setName] = useState(address?.name || "");
  const [contactPerson, setContactPerson] = useState(address?.contactPerson || "");
  const [gstNumber, setGSTNumber] = useState(address?.gstNumber || "")
  const [addressLine1, setAddressLine1] = useState(address?.addressLine1 || "");
  const [addressLine2, setAddressLine2] = useState(address?.addressLine2 || "");
  const [city, setCity] = useState(address?.city || "");
  const [state, setState] = useState(address?.state || "");
  const [zipCode, setZipCode] = useState(address?.zipCode || "");
  const [country, setCountry] = useState(address?.country || "");
  const [transport, setTransport] = useState(address?.transport || "");
  const [phoneNumber, setPhoneNumber] = useState(address?.phoneNumber || "");
  const [errors, setErrors] = useState({});

  const validateField = (field, value, required = true, maxLength) => {
    if (required && !value) return `${field} is required`;
    if (value && maxLength && value.length > maxLength) return `${field} cannot exceed ${maxLength} characters`;
    return null;
  };
  
  const validateForm = () => {
    const newErrors = {};
    newErrors.name = validateField("Company Name", name, true, 200);
    newErrors.contactPerson = validateField("Contact Person", contactPerson, true, 200);
    newErrors.gstNumber = validateField("GST Number", gstNumber, true, 50);
    newErrors.addressLine1 = validateField("Address Line 1", addressLine1, true, 100);
    newErrors.addressLine2 = validateField("Address Line 2", addressLine2, false, 100);
    newErrors.city = validateField("City", city, true, 50);
    newErrors.state = validateField("State", state, true, 50);
    newErrors.zipCode = validateField("Pin Code", zipCode, true, 6);
    newErrors.country = validateField("Country", country, true, 50);
    newErrors.phoneNumber = validateField("Phone Number", phoneNumber, true, 40);
    newErrors.transport = validateField("Transport", transport, true, 200);
  
    Object.keys(newErrors).forEach((key) => {
      if (newErrors[key] === null) delete newErrors[key];
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    let loginUserId = localStorage.getItem("geniusBabySiteUserId");
    const newAddress = {
      addressId: 0,
      name: name,
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      city: city,
      state: state,
      country: country,
      zipCode: zipCode,
      isDeliveryAddress: false,
      phoneNumber: phoneNumber,
      userId: loginUserId,
      createdBy: loginUserId,
      updatedBy: loginUserId,
      isBillingAddress: false,
      contactPerson: contactPerson,
      gstNumber: gstNumber,
      transport: transport,
    };

    if (address) {
      newAddress.addressId = address.addressId;
      newAddress.updatedDate = address.updatedDate;
      const updatedAddress = await updateAddress(address.addressId, newAddress);
      onSave(updatedAddress);
    } else {
      const createdAddress = await addAddress(newAddress);
      onSave(createdAddress);
    }
  };

  const addAddress = async (address) => {
    try {
      const response = await apiStore.post("/Address", address);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  const updateAddress = async (id, address) => {
    try {
      const response = await apiStore.put(`/Address/${id}`, address);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form className="address-form" onSubmit={handleSubmit}>
      <label>
        Company Name:
        <input type="text" value={name} onChange={(event) => setName(event.target.value)} />
        {errors.name && <div style={{ color: "red" }}>{errors.name}</div>}
      </label>
      <label>
        Contact Person:
        <input type="text" value={contactPerson} onChange={(event) => setContactPerson(event.target.value)} />
        {errors.contactPerson && <div style={{ color: "red" }}>{errors.contactPerson}</div>}
      </label>
      <label>
        GST Number:
        <input type="text" value={gstNumber} onChange={(event) => setGSTNumber(event.target.value)} />
        {errors.gstNumber && <div style={{ color: "red" }}>{errors.gstNumber}</div>}
      </label>
      <label>
        Address Line 1:
        <input type="text" value={addressLine1} onChange={(event) => setAddressLine1(event.target.value)} />
        {errors.addressLine1 && <div style={{ color: "red" }}>{errors.addressLine1}</div>}
      </label>
      <label>
        Address Line 2:
        <input type="text" value={addressLine2} onChange={(event) => setAddressLine2(event.target.value)} />
      </label>
      <label>
        City:
        <input type="text" value={city} onChange={(event) => setCity(event.target.value)} />
        {errors.city && <div style={{ color: "red" }}>{errors.city}</div>}
      </label>
      <label>
        Pin Code:
        <input type="text" value={zipCode} onChange={(event) => setZipCode(event.target.value)} />
        {errors.zipCode && <div style={{ color: "red" }}>{errors.zipCode}</div>}
      </label>
      <label>
        State:
        <input type="text" value={state} onChange={(event) => setState(event.target.value)} />
        {errors.state && <div style={{ color: "red" }}>{errors.state}</div>}
      </label>
      <label>
        Country:
        <input type="text" value={country} onChange={(event) => setCountry(event.target.value)} />
        {errors.country && <div style={{ color: "red" }}>{errors.country}</div>}
      </label>
      <label>
        Phone Number:
        <input type="text" value={phoneNumber} onChange={(event) => setPhoneNumber(event.target.value)} />
        {errors.phoneNumber && <div style={{ color: "red" }}>{errors.phoneNumber}</div>}
      </label>
      <label>
        Transport:
        <input type="text" value={transport} onChange={(event) => setTransport(event.target.value)} />
        {errors.transport && <div style={{ color: "red" }}>{errors.transport}</div>}
      </label>
      <button type="submit">Save</button>
      <button type="button" onClick={onCancel}>
        Cancel
      </button>
    </form>
  );
};

export default AddressForm;
